import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=5422cb74&"
import script from "./PageTwo.vue?vue&type=script&lang=js&"
export * from "./PageTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports